import * as React from "react";
import ButtonSwitch from "../../ButtonSwitch";
import MaterialCustomSelectDate from "../../../features/SmartFilters/MaterialCustomSelectDate";
import { useHubx } from "../../../HubX";
import {
  EVENT_INSTALLATION_CONSUMPTION_DATE_CHANGE,
  EVENT_INSTALLATION_CONSUMPTION_NORMALIZE_DATA_CONFIG_CHANGE,
} from "../../../Events";

function ConsumptionFilter() {
  const [normalizeData, setNormalizeData] = React.useState(true);

  const hub = useHubx();

  const handleClick = (newValue: boolean) => {
    setNormalizeData(newValue);
    hub.notify(EVENT_INSTALLATION_CONSUMPTION_NORMALIZE_DATA_CONFIG_CHANGE, newValue);
  };

  return (
    <>
      {/* <ButtonSwitch
        onClick={handleClick}
        label="Dados Normalizados"
        onLabel="Sim"
        offLabel="Não"
        value={normalizeData}
      /> */}

      <MaterialCustomSelectDate event={EVENT_INSTALLATION_CONSUMPTION_DATE_CHANGE} />
    </>
  );
}

export default ConsumptionFilter;
